import { ReactNode, useRef } from "react";
import { motion, useInView } from "framer-motion";
import { fadeInUp, getResponsiveVariants } from "../../utils/animation";

interface AnimatedSectionProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  threshold?: number;
  variants?: any;
  once?: boolean;
}

const AnimatedSection = ({
  children,
  className = "",
  delay = 0,
  threshold = 0.1,
  variants = fadeInUp,
  once = true,
}: AnimatedSectionProps) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once, threshold });

  // Use responsive animation variants that respect reduced motion preference
  const responsiveVariants = getResponsiveVariants(variants);

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={responsiveVariants}
      transition={{ delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedSection;
